// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editable-list > div > .ui-dropdown > button {\n  background-color: transparent;\n  border: 1px solid var(--brand);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.editable-list > .display-flex > button.delete-button.ui-button {\n  background: var(--danger);\n  border: 0;\n  padding: 0.5rem 1rem;\n  margin: 0.5rem 0.5rem 0.5rem 2rem;\n  margin-bottom: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
